module.exports = {"id":"193177","name":"Adama Traoré","rating":"72","photo":"./data/images/photos/4/193177.png","club":{"name":"Göztepe","logo":"./data/images/clubs/Goztepe.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdamaTraore0.json
// module id = 89
// module chunks = 0